import { loadSlim } from '@tsparticles/slim'
import Particles from '@tsparticles/vue3'

import VxeUI from 'vxe-pc-ui'
import VxeUITable from 'vxe-table'
import WeyonUI from 'weyon-ui-common'
// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'
import icons from '@/iconify/index.json'

// 自定义指令
import directive from '@/utils/directive'
import App from './App.vue'
import router from './router'
import pinia from './store'

import uiProvider from './ui/provider'

import '@/utils/systemCopyright'
import '@/utils/baidu'

import 'vxe-table/lib/style.css'
import 'vxe-pc-ui/lib/style.css'

// 加载 svg 图标
import 'virtual:svg-icons-register'
// UnoCSS
import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
import 'weyon-ui-common/dist/style.css'
// 全局样式
import '@/assets/styles/globals.css'

const app = createApp(App)
app.use(VxeUI).use(VxeUITable)
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(WeyonUI)
app.use(Particles as any, {
  init: async (engine: any) => {
    await loadSlim(engine)
  },
})
directive(app)
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

app.mount('#app')
